import { useIntl } from "react-intl";
import { Control } from "react-hook-form";

import { PostMeetingFormWithSummary } from "../form";
import { FIELD_LABELS } from "../messages";

import TextField from "./TextField";

export interface NotesFieldProps {
  control: Control<PostMeetingFormWithSummary>;
}

export default function NotesField({ control }: NotesFieldProps) {
  const { $t } = useIntl();
  return (
    <TextField name="notes" label={$t(FIELD_LABELS.notes)} control={control} />
  );
}
